import clsx from "clsx";
import { FC, KeyboardEvent, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { ICoursesCalendarSlotDto, onActivateKeyDown } from "@ryde/shared";

import { buildCoursesCalendarCourseRouteTypeTooltip } from "./courses-calendar-cell.tooltip-utils";

interface ICoursesCalendarCellCourseNameProps {
  slot: ICoursesCalendarSlotDto;
  courseOpenClassName?: string;
  tooltipDisabled?: boolean;
  onOpenCourseClick: (e: MouseEvent | KeyboardEvent, courseId: number) => void;
}

export const CoursesCalendarCellCourseName: FC<
  ICoursesCalendarCellCourseNameProps
> = ({ slot, courseOpenClassName, tooltipDisabled, onOpenCourseClick }) => {
  const { t } = useTranslation();
  const tooltip = buildCoursesCalendarCourseRouteTypeTooltip({ t, slot });

  return (
    <span className="cc-course-name-wrap">
      <FramerTooltip
        content={tooltip}
        tooltipDisabled={tooltipDisabled}
        triggerContainerDisplay="block"
      >
        <span
          className={clsx(
            "cc-course-name-cell",
            courseOpenClassName,
            courseOpenClassName && "cc-course-name-cell--link",
          )}
          data-e2e="cc-course-name"
          title={slot.courseName}
          onClick={e => onOpenCourseClick(e, slot.courseId)}
          onKeyDown={onActivateKeyDown(e =>
            onOpenCourseClick(e, slot.courseId),
          )}
          role="button"
          tabIndex={0}
        >
          {slot.courseName}
        </span>
      </FramerTooltip>
    </span>
  );
};
